const buttonConfirmTenant = {
  text: 'Add access'
};

export default buttonConfirmTenant;
